import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const AdminSetupGuide = () => {
  const [showPassword, setShowPassword] = useState(false);

  const adminCredentials = {
    email: 'admin@the-apn.com',
    password: 'AdminAPN2024!Secure',
    name: 'APN Administrator'
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">🔐 Admin Setup Guide</h1>
        
        <div className="space-y-6">
          {/* Step 1: Admin Credentials */}
          <div className="bg-blue-50 border border-blue-200 rounded-md p-6">
            <h2 className="text-lg font-semibold text-blue-900 mb-4">Step 1: Admin Account Credentials</h2>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="font-medium text-blue-800">Email:</span>
                <div className="flex items-center space-x-2">
                  <code className="bg-blue-100 px-2 py-1 rounded text-blue-900">{adminCredentials.email}</code>
                  <button
                    onClick={() => copyToClipboard(adminCredentials.email)}
                    className="text-blue-600 hover:text-blue-800 text-sm"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-medium text-blue-800">Password:</span>
                <div className="flex items-center space-x-2">
                  <code className="bg-blue-100 px-2 py-1 rounded text-blue-900">
                    {showPassword ? adminCredentials.password : '••••••••••••••••'}
                  </code>
                  <button
                    onClick={() => setShowPassword(!showPassword)}
                    className="text-blue-600 hover:text-blue-800 text-sm"
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                  <button
                    onClick={() => copyToClipboard(adminCredentials.password)}
                    className="text-blue-600 hover:text-blue-800 text-sm"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-medium text-blue-800">Name:</span>
                <code className="bg-blue-100 px-2 py-1 rounded text-blue-900">{adminCredentials.name}</code>
              </div>
            </div>
          </div>

          {/* Step 2: Setup Instructions */}
          <div className="bg-green-50 border border-green-200 rounded-md p-6">
            <h2 className="text-lg font-semibold text-green-900 mb-4">Step 2: Setup Instructions</h2>
            <ol className="list-decimal list-inside space-y-2 text-green-800">
              <li>
                <Link to="/register" className="text-green-600 hover:text-green-800 underline">
                  Go to the registration page
                </Link> and create an account with the credentials above
              </li>
              <li>After signup, you'll be redirected to a pending approval page</li>
              <li>
                <Link to="/admin/approval" className="text-green-600 hover:text-green-800 underline">
                  Go to the admin approval page
                </Link> and click "Approve Admin Account"
              </li>
              <li>Refresh the page or sign out and sign back in</li>
              <li>You should now have full admin access!</li>
            </ol>
          </div>

          {/* Step 3: Quick Actions */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-6">
            <h2 className="text-lg font-semibold text-yellow-900 mb-4">Step 3: Quick Actions</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Link
                to="/register"
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-200 text-center"
              >
                Create Admin Account
              </Link>
              <Link
                to="/login"
                className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition duration-200 text-center"
              >
                Login to Existing Account
              </Link>
              <Link
                to="/admin/approval"
                className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition duration-200 text-center"
              >
                Approve Admin Status
              </Link>
              <Link
                to="/admin/seed-data"
                className="bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition duration-200 text-center"
              >
                Seed Sample Data
              </Link>
            </div>
          </div>

          {/* Step 4: Testing */}
          <div className="bg-gray-50 border border-gray-200 rounded-md p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Step 4: Test Admin Features</h2>
            <p className="text-gray-700 mb-4">Once you have admin access, test these features:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-700">
              <li>Admin Dashboard - View analytics and manage users</li>
              <li>Groups Management - Create and manage groups</li>
              <li>User Approval - Approve pending member accounts</li>
              <li>Data Seeding - Create sample data for testing</li>
              <li>Firebase Testing - Test database connections</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSetupGuide;
